module.exports = __webpack_public_path__ + "static/media/grabaseat1_preview.9fd7d197.jpg";